<template lang="pug">
div
  el-row.labelStyle
    el-col(:span="12", v-if="cadastrante.pessoa.cadastranteInterno")
      app-display(
        label="Processo feito por funcionário do ITERMA?:",
        :content="verificaCadastranteInterno()",
      )
  el-row.labelStyle()
    el-col(:span="12")
      div(
        v-if="cadastrante.pessoa.pessoaFisica && cadastrante.pessoa.pessoaFisica.cpf",
        key="pessoaFisica"
      )
        app-display(
          id="NOME_CADASTRANTE",
          label="Nome:",
          :content="cadastrante.pessoa.pessoaFisica.nome"
          v-if="cadastrante.pessoa.pessoaFisica.nome"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouNome ? 'text': '' "
        )
        app-display(
          id="CPF_CADASTRANTE",
          label="CPF:",
          :content="cadastrante.pessoa.pessoaFisica.cpf",
          v-if="cadastrante.pessoa.pessoaFisica.cpf"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouCPF ? 'text': '' "
        )
        app-display(
          label="RG:",
          :content="cadastrante.pessoa.pessoaFisica.rg"
          v-if="cadastrante.pessoa.pessoaFisica.rg"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouRG ? 'text': '' "
        )
        app-display(
          label="Naturalidade:",
          :content="cadastrante.pessoa.pessoaFisica.municipioEstadoNaturalidade",
          v-if="cadastrante.pessoa.pessoaFisica.municipioEstadoNaturalidade"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouNaturalidade ? 'text': '' "
        )
      div(v-if="cadastrante.pessoa.pessoaJuridica && cadastrante.pessoa.pessoaJuridica.cnpj")
        app-display(
          label="CNPJ:",
          :content="cadastrante.pessoa.pessoaJuridica.cnpj",
          v-if="cadastrante.pessoa.pessoaJuridica.cnpj"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouCNPJ ? 'text': '' "
        )
        app-display(
          label="Razão Social:",
          :content="cadastrante.pessoa.pessoaJuridica.razaoSocial",
          v-if="cadastrante.pessoa.pessoaJuridica.razaoSocial"
          :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouRazaoSocial ? 'text': '' "
        )
        app-display(
          label="CPF do representante legal:",
          :content="cadastrante.pessoa.pessoaJuridica.cpf",
          v-if="cadastrante.pessoa.pessoaJuridica.cpf"
          :class = "compararCadastrante && compararCadastrante.mudouRepresentanteLegal && compararCadastrante.mudouRepresentanteLegal.mudouPessoa.mudouCPF ? 'text': '' "
        )

    el-col(
      :span="12",
      v-if="cadastrante.pessoa.pessoaJuridica && cadastrante.pessoa.pessoaJuridica.cnpj"
    )
      app-display(
        label="Nome do representante legal:",
        :content="cadastrante.pessoa.pessoaJuridica.nome",
        v-if="cadastrante.pessoa.pessoaJuridica.nome"
        :class = "compararCadastrante && compararCadastrante.mudouRepresentanteLegal && compararCadastrante.mudouRepresentanteLegal.mudouPessoa.mudouNome ? 'text': '' "
      )
      app-display-multiple(
        label="Telefone(s):",
        :content="cadastrante.pessoa.telefones"
        v-if="cadastrante.pessoa.telefones"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouTelefones ? 'text': '' "
      )
      app-display(
        label="E-mail:",
        :content="cadastrante.pessoa.email"
        v-if="cadastrante.pessoa.email"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouEmail ? 'text': '' "
      )

    el-col(
      :span="12",
      v-if="cadastrante.pessoa.pessoaFisica && cadastrante.pessoa.pessoaFisica.cpf && !isProcessoFisico"
    )
      app-display(
        id="EMAIL",
        label="E-mail:",
        :content="cadastrante.pessoa.email"
        v-if="cadastrante.pessoa.email"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouEmail ? 'text': '' "
      )
      app-display(
        label="Data de nascimento:",
        :content="cadastrante.pessoa.pessoaFisica.dataNascimento"
        v-if="cadastrante.pessoa.pessoaFisica.dataNascimento && !isReurb"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouDataNascimento ? 'text': '' "
      )
      app-display(
        label="Estado civil:",
        :content="cadastrante.pessoa.pessoaFisica.estadoCivil"
        v-if="cadastrante.pessoa.pessoaFisica.estadoCivil && !isReurb"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouEstadoCivil ? 'text': '' "
      )
      app-display.margin-top(
        label="Órgão expedidor:",
        :content="cadastrante.pessoa.pessoaFisica.orgaoExpedidor.nome"
        v-if="cadastrante.pessoa.pessoaFisica.orgaoExpedidor && !isReurb"
        :class = "compararCadastrante && compararCadastrante.mudouPessoa && compararCadastrante.mudouPessoa.mudouOrgaoExpedidor ? 'text': '' "
      )

      informacoes-especiais-cadastrante(
        v-if="this.cadastrante.tipo",
        :cadastrante="cadastrante",
        :isOnerosoGroup="isOnerosoGroup",
        :mudouEspeciaisCadastrante="compararCadastrante"
      )
  el-row.margin-top(v-if="!isProcessoFisico")
    el-col
      app-divider(label="Endereço")
        informacoes-endereco.margin-top(:endereco="enderecoCadastrante", slot="body", :mudouEndereco="compararCadastrante && compararCadastrante.mudouPessoa.mudouEndereco")

</template>

<script>
import AppDivider from '../../AppDivider'
import AppDisplay from '../../AppDisplay'
import InformacoesEndereco from '.././ma/InformacoesEndereco'
import InformacoesEspeciaisCadastrante from '.././InformacoesEspeciaisCadastrante'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import compararReticacoesDefault from '../../../utils/pa/compararReticacoesDefault'

export default {
  props: {
    cadastrante: {
      type: Object,
      required: true
    },
    isOnerosoGroup: {
      type: Boolean,
      required: true
    },
    compararCadastrante: {
      type: Object,
      default: compararReticacoesDefault.mudouCadastranteDTODefault
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    },
    isReurb: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    AppDisplay,
    InformacoesEndereco,
    AppDivider,
    InformacoesEspeciaisCadastrante,
    AppDisplayMultiple
  },
  computed: {
    enderecoCadastrante () {
      return this.cadastrante.pessoa.endereco ? this.cadastrante.pessoa.endereco : {}
    }
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero
        } else {
          return telefone
        }
      })
    },
    verificaCadastranteInterno () {
      if (this.cadastrante?.pessoa?.cadastranteInterno !== null && this.cadastrante?.pessoa?.cadastranteInterno !== undefined) {
        return this.cadastrante?.pessoa?.cadastranteInterno ? 'Sim' : 'Não'
      }
      return '-'
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin-top {
    margin-top: 10px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {
    .labelStyle {
      display: flex;
      flex-direction: column;
      width: 395px;
    }

    .margin-top {
      display: flex;
      flex-direction: column;
      width: 490px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesCadastrante.vue